import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { AppState } from '~/reducers';

interface StateProps {
  isTagRelationshipsLoading: boolean;
}

export type Props = StateProps;
const TagRelationshipIsLoadingWarning: React.FC<Props> = (props) => {
  useEffect(() => {
    const onClose = (e: BeforeUnloadEvent) => {
      if (props.isTagRelationshipsLoading) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    };

    window.addEventListener('beforeunload', onClose);
    return () => {
      window.removeEventListener('beforeunload', onClose);
    };
  }, [props.isTagRelationshipsLoading]);

  return null;
};

const mapStateToProps = ({ assetTagRelationships }: AppState): StateProps => ({
  isTagRelationshipsLoading: assetTagRelationships.isLoading,
});

export default connect(mapStateToProps)(TagRelationshipIsLoadingWarning);
